import {
    animation, trigger, animateChild, group,
    transition, animate, style, query, state
} from '@angular/animations';

// export const slideInOutAnimationtest = animation([
//     style({ transform: 'translateX(-100%)' }),
//     animate('200ms ease-in', style({ transform: 'translateY(0%)' }))
// ]);

export const slideInOutAnimation = trigger('slideInOut', [
    state('show', style({
        'opacity':1.0,
        'transform': 'translate3d(0px,0px,0px)'
    })),
    state('hide', style({
        //'box-shadow': 'none',
        //'visibility': 'hidden',
        'opacity':0.5,
        //transform: 'translateX(-100%)'
        'transform': 'translate3d(100%,0,0)'
    })),
    transition(':enter', [
        style({ 'transform': 'translate3d(100%,0,0)' }),
        animate('200ms ease-in')
      ]),
    transition('show=>hide', [
       // style({ transform: 'translateX(-100%)' }),
        // animate('200ms ease-in')
        animate('200ms ease-in', style({'transform': 'translate3d(-100%,0,0)'}))
    ]),
    transition('hide=>show', [
        animate('200ms ease-in')
        // animate('800ms ease-in', style({ transform: 'translateX(-100%)' }))
    ])
])